import { render } from "./ShipmentListBlock.vue?vue&type=template&id=ca4c7a74"
import script from "./ShipmentListBlock.vue?vue&type=script&lang=js"
export * from "./ShipmentListBlock.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\甘小星\\Desktop\\sakai-vue-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__